export default class JobCreateGeneral {
  static selectorString() {
    return '.JobCreateGeneral';
  }

  getSelectedAddress() {
    const selectedOption = this.addressField.querySelector(
      `option[value="${this.addressField.value}"]`,
    );

    if (!selectedOption) {
      return null;
    }

    return selectedOption.innerHTML;
  }

  getWorkTimes() {
    return this.workTimeFields
      .filter(field => field.checked)
      .map(field => field.getAttribute('data-label'));
  }

  getEmploymentTypes() {
    return this.employmentTypesFields
      .filter(field => field.checked)
      .map(field => field.getAttribute('data-label'));
  }

  getJobTitle() {
    return this.jobTitleField.value;
  }

  setJobTitle(value) {
    this.jobTitleField.value = value;
  }

  render(node, props) {
    this.addressField = node.querySelector('[name="address"]');
    this.workTimeFields = [...node.querySelectorAll('[name="workTimes[]"]')];
    this.employmentTypesFields = [...node.querySelectorAll('[name="employmentTypes[]"]')];
    this.jobTitleField = node.querySelector('[name="jobTitle"]');
  }
}
